const initState = {

    admin_users: [],
    error_message: null,
    edit_user_overlay: null,
    created: false

};

const adminReducer = (state = initState, action) => {


    switch (action.type) {

        case "RESET_ADMIN_ERROR":
            return {
                ...state,
                error_message: null,
                created: false
            };

        case "ADMIN_ERROR":
            return {
                ...state,
                error_message: action.error
            };

        case "ADMIN_USERS_UPDATED":
            return {
                ...state,
                admin_users: action.users,
                created: true
            };

        case "ADMIN_USERS_CREATED":
            return {
                ...state,
                admin_users: action.users,
                created: true
            };

        case "ADMIN_USERS":
            return {
                ...state,
                admin_users: action.users,
            };

        case "EDIT_USER_OVERLAY":
            return {
                ...state,
                edit_user_overlay: action.user_id
            };

        case "RESET_EDIT_USER_OVERLAY":
            return {
                ...state,
                edit_user_overlay: null
            };

        default:
            return state;
    }
};

export default adminReducer;
